//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'
import { GOAL_ID_BY_TYPE } from '@/constants/goalIdByType'

export default {
  props: {
    /**
     * Area page: diet | sex-drive | stress | energy | sleep
     */
    area: {
      type: String,
      required: true
    },
    /**
     * Goal name for the new quiz
     */
    goalName: {
      type: String,
      default: null
    },
    goalIdParam: {
      type: Number,
      default: -1
    },
    goalNameParam: {
      type: String,
      default: null
    }
  },
  computed: {
    ...mapState('quiz', ['goalId']),
    title () {
      const date = this.getDateFormatted(2, 7)
      if (GOAL_ID_BY_TYPE.TO_IMPROVE.includes(this.goalId)) {
        return this.$t('quizResults.timelineB.titleDynamic.improve', { goalName: this.goalName, date })
      } else if (GOAL_ID_BY_TYPE.TO_IMPROVE.includes(this.goalIdParam)) {
        return this.$t('quizResults.timelineB.titleDynamic.improve', { goalName: this.goalNameParam, date })
      } else if (GOAL_ID_BY_TYPE.TO_MANAGE.includes(this.goalId)) {
        return this.$t('quizResults.timelineB.titleDynamic.manage', { goalName: this.goalName, date })
      } else if (GOAL_ID_BY_TYPE.TO_MANAGE.includes(this.goalIdParam)) {
        return this.$t('quizResults.timelineB.titleDynamic.manage', { goalName: this.goalNameParam, date })
      } else {
        return this.$t('quizResults.timelineB.goalNameTitle', { goalName: this.goalName, date })
      }
    }
  },
  methods: {
    getThingImage (thing) {
      return `img/things_to_learn_${this.area}_${thing}.png`
    },
    getDateFormatted (monthFromNow, daysFromNow = 0) {
      let date = new Date()
      date.setMonth(date.getMonth() + monthFromNow)
      date.setDate(date.getDate() + daysFromNow)
      const day = date.getDate()
      const suffix = (day === 1 || day === 31) ? 'st' : (day === 2 || day === 22) ? 'nd' : (day === 3) ? 'rd' : 'th'
      date = date.toDateString().substring(4, 10)
      return `${date}${suffix}`
    }
  }
}
